import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Box, Card, Heading, Spinner, Text, Button, Table, Thead, Tbody, Tr, Th, Td, Badge } from '@chakra-ui/react';
import { ArrowBackIcon } from '@chakra-ui/icons';
import Axios from '../utils/httpClient';
import Layout from './Layout';

const PRIMARY = '#133654';

const TeachersWithPointsRange = () => {
  const navigate = useNavigate();
  const { range } = useParams();
  const [loading, setLoading] = useState(false);
  const [teachers, setTeachers] = useState([]);

  // Load teachers with points in the specified range
  useEffect(() => {
    if (!range) return;

    setLoading(true);
    Axios().get(`api/v1/application/all-teachers-overall-points/`)
      .then(res => {
        const allTeachers = res?.data?.teachers || [];

        // Filter teachers based on the range
        let filteredTeachers = [];
        switch (range) {
          case '100-70':
            filteredTeachers = allTeachers.filter(teacher => teacher.total_points >= 70 && teacher.total_points <= 100);
            break;
          case '70-50':
            filteredTeachers = allTeachers.filter(teacher => teacher.total_points >= 50 && teacher.total_points < 70);
            break;
          case '50-30':
            filteredTeachers = allTeachers.filter(teacher => teacher.total_points >= 30 && teacher.total_points < 50);
            break;
          case '30-0':
            filteredTeachers = allTeachers.filter(teacher => teacher.total_points >= 0 && teacher.total_points < 30);
            break;
          default:
            filteredTeachers = [];
        }

        setTeachers(filteredTeachers);
      })
      .catch(e => {
        console.error('Error loading teachers with points:', e);
        setTeachers([]);
      })
      .finally(() => setLoading(false));
  }, [range]);

  // Get range title
  const getRangeTitle = () => {
    switch (range) {
      case '100-70': return '100-70 ball';
      case '70-50': return '70-50 ball';
      case '50-30': return '50-30 ball';
      case '30-0': return '30-0 ball';
      default: return range;
    }
  };

  return (
    <Layout showLoginButton={true}>
      <Box p={4}>
        <Button
          onClick={() => navigate(-1)}
          mb={3}
          color="white"
          bg="#133654"
          _hover={{ bg: "#133654" }}
        >
          <ArrowBackIcon />
          <span style={{ marginLeft: 5 }}>Orqaga</span>
        </Button>

        <Box display="flex" justifyContent="space-between" alignItems="center" mb={4}>
          <Heading size="md">
            {getRangeTitle()} oralig'idagi o'qituvchilar ({teachers.length} ta)
          </Heading>
        </Box>

        <Card style={{ padding: 16 }}>
          <Heading size="sm" mb={4}>
            {loading
              ? "O'qituvchilar yuklanmoqda..."
              : `${getRangeTitle()} oralig'idagi o'qituvchilar`
            }
          </Heading>

          {loading ? (
            <Box display="flex" justifyContent="center" p={8}>
              <Spinner size="xl" color={PRIMARY} />
            </Box>
          ) : teachers.length === 0 ? (
            <Text color="gray.600">Bu oralikda baholangan o'qituvchilar topilmadi</Text>
          ) : (
            <Table variant="simple" size="sm">
              <Thead>
                <Tr bg="gray.50">
                  <Th width="60px">No</Th>
                  <Th>O'qituvchi</Th>
                  <Th width="120px" textAlign="right">Jami ball</Th>
                </Tr>
              </Thead>
              <Tbody>
                {teachers.map((teacher, index) => (
                  <Tr 
                    key={teacher.id} 
                    _hover={{ bg: 'gray.100', cursor: 'pointer' }}
                    onClick={() => navigate('/login')}
                  >
                    <Td>
                      <Badge
                        colorScheme={teacher.rank === 1 ? 'yellow' : teacher.rank === 2 ? 'gray' : teacher.rank === 3 ? 'orange' : 'blue'}
                        fontSize="md"
                        px={3}
                        py={1}
                        borderRadius="full"
                      >
                        {teacher.rank}
                      </Badge>
                    </Td>
                    <Td>
                      <Text fontWeight={600}>
                        {teacher.last_name} {teacher.first_name} {teacher.middle_name || ''}
                      </Text>
                      <Text fontSize="xs" color="gray.600">{teacher.kafedra_name}</Text>
                    </Td>
                    <Td textAlign="right">
                      <Text fontWeight={700} fontSize="lg" color={PRIMARY}>
                        {teacher.total_points.toFixed(2)}
                      </Text>
                    </Td>
                  </Tr>
                ))}
              </Tbody>
            </Table>
          )}
        </Card>
      </Box>
    </Layout>
  );
};

export default TeachersWithPointsRange;